import axios from './XesAxios'
import { XesAxios } from '@xes/terra-utils'
import envConfig from './config'
import config from '../config/index'
const { env, mock, baseApi, mockApi } = envConfig

console.log(config.sGroupId)

let BASE_URL = ''
const BASE_BUCHKET_URL = '//booster.xueersi.com'
if (env === 'production') {
  BASE_URL = baseApi
} else {
  BASE_URL = mock ? mockApi : baseApi
}

export default {
  // 获取网校云Bucket的uploadToken formdata...
  getuploadtoken(params) {
    return XesAxios.post(`${BASE_BUCHKET_URL}/h5EditStation/Bucket/Token`, params)
  },
  addInfo(params) {
    return axios.post(`${BASE_URL}/artical/submit`, { ...params, sGroupId: config.sGroupId })
  },
  newGetUploadToken(parmas) {
    return XesAxios.post(`${BASE_BUCHKET_URL}/h5EditStation/Bucket/ActivityToken`, parmas)
  },
}
